/** common */

// 店铺/国家
export const GET_COUNTRIES = 'getCountries';
export const GET_MARKETS = 'getMarkets';
export const GET_ADMARKETS = 'getAdMarkets';
export const GET_AUTH_COUNTRIES = 'getAuthCountries';
export const GET_AUTH_MARKETS = 'getAuthMarkets';

/**
 * user
 */

export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const GET_INFO = 'getInfo';
export const RESET_USER = 'RESET_USER';
export const GET_INFO_SUCCESS = 'getInfoSuccess';
export const GET_USER_OPTIONS = 'getUserOptions';
export const GET_ACTIVE_USER_OPTIONS = 'getActiveUserOptions';
export const REGISTER = 'registerUser';
export const USER_LOGIN = `user/${LOGIN}`;
export const USER_LOGOUT = `user/${LOGOUT}`;
export const USER_GET_INFO = `user/${GET_INFO}`;
export const USER_RESET_USER = `user/${RESET_USER}`;
export const USER_REGISTER = `user/${REGISTER}`;
export const USER_GET_USER_OPTIONS = `user/${GET_USER_OPTIONS}`;
export const USER_GET_ACTIVE_USER_OPTIONS = `user/${GET_ACTIVE_USER_OPTIONS}`;
export const GET_TENANT_PAY = 'getTenantPay';
export const GET_POLLING = 'getPolling';
export const USER_GET_POLLING = `user/${GET_POLLING}`;

/**
 * warehouse
 */
export const GET_WAREHOUSE_TREE = 'GET_WAREHOUSE_TREE';
export const WAREHOUSE_GET_WAREHOUSE_TREE = `warehouse/${GET_WAREHOUSE_TREE}`;

export const GET_ACTIVE_WAREHOUSE_TREE = 'GET_ACTIVE_WAREHOUSE_TREE';
export const WAREHOUSE_GET_ACTIVE_WAREHOUSE_TREE = `warehouse/${GET_ACTIVE_WAREHOUSE_TREE}`;

export const GET_FBA_WAREHOUSE_TREE = 'GET_FBA_WAREHOUSE_TREE';
export const WAREHOUSE_GET_FBA_WAREHOUSE_TREE = `warehouse/${GET_FBA_WAREHOUSE_TREE}`;

export const GET_ACTIVE_FBA_WAREHOUSE_TREE = 'GET_ACTIVE_FBA_WAREHOUSE_TREE';
export const WAREHOUSE_GET_ACTIVE_FBA_WAREHOUSE_TREE = `warehouse/${GET_ACTIVE_FBA_WAREHOUSE_TREE}`;

export const GET_SELF_WAREHOUSE_TREE = 'GET_SELF_WAREHOUSE_TREE';
export const WAREHOUSE_GET_SELF_WAREHOUSE_TREE = `warehouse/${GET_SELF_WAREHOUSE_TREE}`;

export const GET_ACTIVE_SELF_WAREHOUSE_TREE = 'GET_ACTIVE_SELF_WAREHOUSE_TREE';
export const WAREHOUSE_GET_ACTIVE_SELF_WAREHOUSE_TREE = `warehouse/${GET_ACTIVE_SELF_WAREHOUSE_TREE}`;

/**
 * product
 */
export const GET_PRODUCT_BRAND = 'GET_PRODUCT_BRAND';
export const PRODUCT_GET_PRODUCT_BRAND = `product/${GET_PRODUCT_BRAND}`;

export const GET_PRODUCT_CATEGORY_TREE = 'GET_PRODUCT_CATEGORY_TREE';
export const PRODUCT_GET_PRODUCT_CATEGORY_TREE = `product/${GET_PRODUCT_CATEGORY_TREE}`;

/**
 * sale
 */

export const GET_OPERATION_STATE = 'GET_OPERATION_STATE';
export const SALE_GET_OPERATION_STATE = `sale/${GET_OPERATION_STATE}`;

/**
 * logistics
 */
export const GET_LOGISTICS_OPTIONS = 'getLogisticsOptions';
export const GET_ACTIVE_LOGISTICS_OPTIONS = 'getActiveLogisticsOptions';
export const LOGISTICS_GET_LOGISTICS_OPTIONS = `logistics/${GET_LOGISTICS_OPTIONS}`;
export const LOGISTICS_GET_ACTIVE_LOGISTICS_OPTIONS = `logistics/${GET_ACTIVE_LOGISTICS_OPTIONS}`;

/**
 * purchase
 */

export const GET_SUPPLIER = 'GET_SUPPLIER';
export const PURCHASE_GET_SUPPLIER = `purchase/${GET_SUPPLIER}`;
export const GET_ACTIVE_SUPPLIER = 'GET_ACTIVE_SUPPLIER';
export const PURCHASE_GET_ACTIVE_SUPPLIER = `purchase/${GET_ACTIVE_SUPPLIER}`;


export const INNER_GET_COMPANY_INFO = 'GET_COMPANY_INFO'


/**
 * statistics
 */



/**
 * dashboard
 */
export const REFRESH_MARKET_AUTH_TYPE =  'refreshMarketAuthType'
export const GET_MARKET_AUTH_TYPE = 'getMarketAuthType'
export const DASHBOARD_REFRESH_MARKET_AUTH_TYPE = `user/${REFRESH_MARKET_AUTH_TYPE}`